import { useQuery } from "@tanstack/react-query"
import { API } from "config"

const useCities = (state_id) => useQuery({ queryKey: [`loc-cities`, state_id], queryFn: async () => {
    if(!state_id) return
    const callback = await API.get(`/common/loc/states/${state_id}/cities`)
    return callback?.data
}, staleTime: 1000 * 60 * 60 * 24 * 7 , gcTime: 1000 * 60 * 60 * 24 * 14 })

export default useCities